import { Schema } from "@effect/schema";
import { Brand, pipe } from "effect";

export const USD_DECIMALS = 6;

type UsdBrand = bigint & Brand.Brand<"Usd">;
const UsdBrand = Brand.nominal<UsdBrand>();

export type Usd = typeof Usd.Type;
export type UsdEncoded = typeof Usd.Encoded;

export const Usd = Schema.BigInt.pipe(Schema.fromBrand(UsdBrand)).annotations({
  identifier: "Usd",
});

export const UsdFromBigInt = Schema.BigIntFromSelf.pipe(
  Schema.fromBrand(UsdBrand)
).annotations({ identifier: "UsdFromBigInt" });

export function makeUsd(value: bigint): Usd {
  return Usd.make(value);
}

export const USD_ZERO = makeUsd(0n);
export const USD_ONE = makeUsd(10n ** BigInt(USD_DECIMALS));
